import React from 'react';

export default class ExportIcon extends React.Component {
  render() {
    const { onClick, title, className = '', disabled = false } = this.props;

    return (
      <button
        className={`export-icon-btn ${className}`}
        onClick={onClick}
        title={title || 'Export to PDF'}
        aria-label={title || 'Export to PDF'}
        type="button"
        disabled={disabled}
      >
        {/* Clean download-document icon: page outline + downward arrow */}
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
          width="18"
          height="18"
          aria-hidden="true"
        >
          {/* page with folded corner */}
          <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
          <path d="M14 3v5h5" />
          {/* download arrow inside */}
          <path d="M12 12v5" />
          <path d="M9.5 14.5 12 17l2.5-2.5" />
        </svg>
      </button>
    );
  }
}
